import { type ServiceType, ServiceTypes } from '@/api/types/Service'
import { formatAsTitle } from '@/utils/format'

const ServiceTypeMeta: Record<ServiceType, {
  name: string,
  description: string,
}> = {
  EMAIL_NOTIFICATIONS: {
    name: 'Email Notification Service - All Users',
    description: 'If turned on, designated users from this organization will get email notifications.',
  },
  PUSH_NOTIFICATIONS: {
    name: 'Push Notification Service - All Users',
    description: 'If turned on, designated users from this organization will get push notifications.',
  },
  WEB_TEXT_CRAWLER: {
    name: 'Web/Text Crawler',
    description: 'If turned on, designated users from this organization will be crawled by the Web/Text Crawler.',
  },
  IMAGE_CRAWLER: {
    name: 'Image Crawler',
    description: 'If turned on, designated users from this organization will be crawled by the Image Crawler.',
  },
  THUMBNAIL_CRAWLER: {
    name: 'Thumbnail Crawler',
    description: 'If turned on, designated users from this organization will be crawled by the Video Crawler.',
  },
}

const ServiceGroupingMeta: Record<string, Partial<ServiceType>[]> = {
  'Notifications': [
    'EMAIL_NOTIFICATIONS',
    'PUSH_NOTIFICATIONS',
  ],
  'Crawlers': [
    'WEB_TEXT_CRAWLER',
    'IMAGE_CRAWLER',
    'THUMBNAIL_CRAWLER',
  ]
}

const ServiceTypeDetails = ServiceTypes.map(key => {
  const meta = ServiceTypeMeta[key] ?? {}
  return {
    key,
    name: meta.name,
    description: meta.description,
  }
})

export const useServices = () => {
  return {
    serviceGrouping: ServiceGroupingMeta,
    getServiceTypeName: (key: ServiceType) => {
      const service = ServiceTypeDetails.find(s => s.key === key)
      return service ? service.name : formatAsTitle(key.replace(/_/g, ' '))
    },
    getServiceTypeDescription: (key: ServiceType) => {
      const service = ServiceTypeDetails.find(s => s.key === key)
      return service?.description || ''
    }
  }
}
